module.exports = __webpack_public_path__ + "img/romantic_poster.3f527307.png";